var _style, _symbol;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTempoUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00FF95;}\r\n\t.st1{fill:#DDFF00;}\r\n\t.st2{fill:#FF0051;}\r\n")), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "New_Symbol",
    viewBox: "-80 -80 160 160"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.4-80H-77.4c-1.4,0-2.6,1.2-2.6,2.6V77.4c0,1.4,1.2,2.6,2.6,2.6H77.4c1.4,0,2.6-1.2,2.6-2.6V-77.4 C80-78.8,78.8-80,77.4-80z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-27.9-36.7h-29.7c-0.2,0-0.3-0.1-0.3-0.3v-19.4c0-0.2,0.1-0.3,0.3-0.3h29.7c0.2,0,0.3,0.1,0.3,0.3V-37 C-27.6-36.8-27.7-36.7-27.9-36.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.8-36.7h-29.7c-0.2,0-0.3-0.1-0.3-0.3v-19.4c0-0.2,0.1-0.3,0.3-0.3h29.7c0.2,0,0.3,0.1,0.3,0.3V-37 C15.1-36.8,15-36.7,14.8-36.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59-36.7H29.3c-0.2,0-0.3-0.1-0.3-0.3v-19.4c0-0.2,0.1-0.3,0.3-0.3H59c0.2,0,0.3,0.1,0.3,0.3V-37 C59.2-36.8,59.1-36.7,59-36.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-27.9,10h-29.7c-0.2,0-0.3-0.1-0.3-0.3V-9.7c0-0.2,0.1-0.3,0.3-0.3h29.7c0.2,0,0.3,0.1,0.3,0.3V9.7 C-27.6,9.9-27.7,10-27.9,10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.8,10h-29.7c-0.2,0-0.3-0.1-0.3-0.3V-9.7c0-0.2,0.1-0.3,0.3-0.3h29.7c0.2,0,0.3,0.1,0.3,0.3V9.7 C15.1,9.9,15,10,14.8,10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59,10H29.3C29.1,10,29,9.9,29,9.7V-9.7c0-0.2,0.1-0.3,0.3-0.3H59c0.2,0,0.3,0.1,0.3,0.3V9.7 C59.2,9.9,59.1,10,59,10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-27.9,56.7h-29.7c-0.2,0-0.3-0.1-0.3-0.3V37c0-0.2,0.1-0.3,0.3-0.3h29.7c0.2,0,0.3,0.1,0.3,0.3v19.4 C-27.6,56.6-27.7,56.7-27.9,56.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.8,56.7h-29.7c-0.2,0-0.3-0.1-0.3-0.3V37c0-0.2,0.1-0.3,0.3-0.3h29.7c0.2,0,0.3,0.1,0.3,0.3v19.4 C15.1,56.6,15,56.7,14.8,56.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59,56.7H29.3c-0.2,0-0.3-0.1-0.3-0.3V37c0-0.2,0.1-0.3,0.3-0.3H59c0.2,0,0.3,0.1,0.3,0.3v19.4 C59.2,56.6,59.1,56.7,59,56.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-57.8-16.6v-2.4h30.2v2.4c0,1.8-1.4,3.2-3.2,3.2h-23.8C-56.4-13.4-57.8-14.8-57.8-16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-55.3-33.4h25.2c1.4,0,2.5,1.1,2.5,2.5v12h-30.2v-12C-57.8-32.2-56.7-33.4-55.3-33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-15.1-16.6v-2.4h30.2v2.4c0,1.8-1.4,3.2-3.2,3.2h-23.8C-13.7-13.4-15.1-14.8-15.1-16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-12.6-33.4h25.2c1.4,0,2.5,1.1,2.5,2.5v12h-30.2v-12C-15.1-32.2-14-33.4-12.6-33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29-18.9v-12c0-1.4,1.1-2.5,2.5-2.5h25.2c1.4,0,2.5,1.1,2.5,2.5v12H29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56-13.4H32.2c-1.8,0-3.2-1.4-3.2-3.2v-2.4h30.2v2.4C59.2-14.8,57.8-13.4,56-13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-54.6,13.4h23.8c1.8,0,3.2,1.4,3.2,3.2v2.4h-30.2v-2.4C-57.8,14.8-56.4,13.4-54.6,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-57.8,30.9v-12h30.2v12c0,1.4-1.1,2.5-2.5,2.5h-25.2C-56.7,33.4-57.8,32.2-57.8,30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-11.9,13.4h23.8c1.8,0,3.2,1.4,3.2,3.2v2.4h-30.2v-2.4C-15.1,14.8-13.7,13.4-11.9,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-15.1,30.9v-12h30.2v12c0,1.4-1.1,2.5-2.5,2.5h-25.2C-14,33.4-15.1,32.2-15.1,30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29,18.9v-2.4c0-1.8,1.4-3.2,3.2-3.2H56c1.8,0,3.2,1.4,3.2,3.2v2.4H29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.7,33.4H31.5c-1.4,0-2.5-1.1-2.5-2.5v-12h30.2v12C59.2,32.2,58.1,33.4,56.7,33.4z"
  })))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#New_Symbol",
    width: 160,
    height: 160,
    id: "XMLID_1_",
    x: -80,
    y: -80,
    transform: "matrix(0.1 0 0 -0.1 8 8)",
    style: {
      overflow: "visible"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempoUp);
export default __webpack_public_path__ + "static/media/tempo-up.1ef3a495fd8a43a88ec8f0c34fc8ddbb.svg";
export { ForwardRef as ReactComponent };